import React from "react"
import PropTypes from "prop-types"
import { Card, CardActions, CardContent, CardHeader, Divider } from '@mui/material'
import Typography from '@mui/material/Typography'

const DashboardCard = ({ title, actions, cardActions, children }) => {
  const cardStyle = {
    borderRadius: ".35rem",
    boxShadow:
      "0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    overflow: "visible",
    overflowX: "visible",
    overflowY: "visible",
    height: "100%",
    display: "flex", 
    flexDirection: "column", 
  }

  return (
    <Card style={cardStyle}>
      {title && (
        <CardHeader
          title={
            <Typography variant="h6" sx={{ fontSize: "1.5rem" }}>
              {title}
            </Typography>
          }
          action={actions}
        />
      )}
      {title && <Divider />}
      <CardContent>{children}</CardContent>
      {cardActions && <Divider />}
      {cardActions && <CardActions>{cardActions}</CardActions>}
    </Card>
  )
}

DashboardCard.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.node,
  cardActions: PropTypes.node,
  children: PropTypes.node.isRequired,
}

DashboardCard.defaultProps = {
  title: null,
  actions: null,
  cardActions: null,
}

export default DashboardCard
